/* eslint-disable complexity */
/* eslint-disable react-hooks/exhaustive-deps */
import { Divider, Row } from 'antd'
import { FC, useEffect } from 'react'
import { BigSale } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { showNotification } from 'src/core/helpers'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import SaleDocumentForm from './SaleDocumentForm/SaleDocumentForm'
import SaleDocumentValid from './SaleDocumentValid/SaleDocumentValid'
import { Loader, CustomLink, CustomCol, CustomTitle } from 'src/components'
import { resetSaleSendDocuments, sendSaleDocumentSelector } from 'src/features'

const SaleDocuments: FC<{ sale: BigSale }> = ({ sale }) => {
  const { t } = useTranslation()
  const isTaxRelief = sale.isTaxRelief
  const isTransfer = sale.fulfillment_type === 'transfer'
  const taxColnumber = isTaxRelief ? 8 : 12
  const { success, error, loading } = useAppSelector(sendSaleDocumentSelector)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (success) {
      showNotification('success', t('general.OperationSuccess'))
      dispatch(resetSaleSendDocuments())
    }
    if (error) {
      showNotification('error', t('Transactions.ErrorSendDocs'))
      dispatch(resetSaleSendDocuments())
    }
  }, [success, error, dispatch])

  return  <>
    <CustomTitle label={t('Transactions.Documents')} type={null} />

    {sale.emissions_certificate && (
      <div className='mb-4'>
        <CustomLink
          label={t('Transactions.Emissions')}
          link={`${sale.url}${sale.emissions_certificate}`}
        />
      </div>
    )}

    <Row>
      <CustomCol lg={taxColnumber}>
        {sale.creditOffsettingReceiptIsValid ? (
          <SaleDocumentValid
            title={t('Transactions.Doc1')}
            label={t('Transactions.Doc2')}
          />
        ) : (
          <SaleDocumentForm
            sale={sale}
            keyField={'creditOffsettingReceipt'}
            keyFile={'creditOffsettingReceipt_file'}
            buttonLabel={!isTransfer ? t('Transactions.Doc3'):
              t('Transactions.UploadInvoice')}
          />
        )}
      </CustomCol>
      <CustomCol lg={taxColnumber}>
        {sale.cancellationCertificateIsValid ? (
          <SaleDocumentValid
            title={t('Transactions.Doc4')}
            label={t('Transactions.Doc5')}
          />
        ) : (
          <SaleDocumentForm
            sale={sale}
            keyField={'cancellationCertificate'}
            keyFile={'cancellationCertificate_file'}
            buttonLabel={!isTransfer ? t('Transactions.Doc6'):
              t('Transactions.UploadTransferCertificate')}
          />
        )}
      </CustomCol>

      {sale.isTaxRelief && (
        <CustomCol lg={8}>
          {/* Tax Document */}
          {sale.isTaxRelief && <>
            {sale.taxReliefDocumentIsValid ? (
              <SaleDocumentValid
                title={t('Transactions.Doc7')}
                label={t('Transactions.Doc8')}
              />
            ) : (
              <SaleDocumentForm
                sale={sale}
                keyField='taxReliefDocument'
                keyFile={'taxReliefDocument_file'}
                buttonLabel={t('Transactions.Doc9')}
              />
            )}
          </>}
        </CustomCol>
      )}
    </Row>

    {/* Agreement document */}
    {sale.projectKind === 'carbon_forward' && <>
      <Divider />
      {sale.isValidCarbonForwardPurchaseAgreementDocument ? (
        <SaleDocumentValid
          title={t('Transactions.Doc10')}
          label={t('Transactions.Doc11')}
        />
      ) : (
        <SaleDocumentForm
          sale={sale}
          keyField='carbonForwardPurchaseAgreementDocument'
          keyFile={'carbonForwardPurchaseAgreementDocument_file'}
          buttonLabel={t('Transactions.Doc12')}
        />
      )}
    </>}

    {loading && <Loader />}
  </>
}

export default SaleDocuments
